export const COUNTRY__AUSTRIA = 'AT';
export const COUNTRY__GERMANY = 'DE';
export const COUNTRY__SWITZERLAND = 'CH';

export function DACH()
{
	return [COUNTRY__AUSTRIA, COUNTRY__GERMANY, COUNTRY__SWITZERLAND];
}
